module.exports = __webpack_public_path__ + "static/media/category.b98468a2.jpg";